import { useMemo } from "react";
import { Route } from "react-router-dom";
import { TabLayout } from "../../ui_elements";

export const ReportsRouter = ({
	component,
	path,
	exact,
	purpose,
	title,
	user,
	...rest
}) => {
	const Component = component;
	const paths = useMemo(
		() => [
			{
				title: "Application Payment Reports",
				path: "/reports/application_payment_reports",
				disabled: false
			},
			{
				title: "Fees Payment Reports",
				path: "/reports/payment_reports",
				disabled: false
			},
			{
				title: "Jupeb Reports",
				path: "/reports/jupeb_reports",
				disabled: false
			},
			{
				title: "PUTME Reports",
				path: "/reports/putme_reports",
				disabled: false
			},
			{
				title: "Matric No. Reports",
				path: "/reports/matric_number_generation_reports",
				disabled: false
			},
			{
				title: "Admission List Report",
				path: "/reports/admission_list",
				disabled: false
			},
			{
				title: "Transfer Reports",
				path: "/app_reports/transfer_reports",
				disabled: false
			},
			{
				title: "DE App Reports",
				path: "/app_reports/de_reports",
				disabled: false
			},
			{
				title: "Full Payment Reports",
				path: "/reports/student_fee_reports",
				disabled: false
			},
			{
				title: "Change of Department Reports",
				path: "/reports/change_of_department_reports",
				disabled: false
			},
			{
				title: "Book Shop Reports",
				path: "/reports/bookshop_reports",
				disabled: false
			},
			{
				title: "Scholarship Reports",
				path: "/reports/scholarship_reports",
				disabled: false
			},
			{
				title: "Hostel Reports",
				path: "/reports/hostel_reports",
				disabled: false
			},
			{
				title: "Hostel Summary Reports",
				path: "/reports/hostel_summary_reports",
				disabled: false
			}
		],
		[]
	);
	return (
		<Route
			exact={exact}
			path={path}
			{...rest}
			render={(props) => {
				return (
					<TabLayout title={title} paths={paths}>
						<Component {...rest} {...props} />
					</TabLayout>
				);
			}}
		/>
	);
};
